"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.array.iterator");
require("core-js/modules/es6.object.to-string");
require("core-js/modules/es6.object.keys");
require("core-js/modules/es6.object.assign");
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null)
    return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
        continue;
    target[key] = source[key];
} return target; }
/*
 * Note: mobileHeroImage is deprecated and should be removed soon.
 */
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const atoms_1 = require("@components/atoms");
const ArticleTeaserOverlap_1 = __importDefault(require("./ArticleTeaserOverlap")); // note: overlap must be imported first
const ArticleTeaserCenter_1 = __importDefault(require("./ArticleTeaserCenter"));
const ArticleTeaserCorner_1 = __importDefault(require("./ArticleTeaserCorner"));
const ArticleTeaserFloat_1 = __importDefault(require("./ArticleTeaserFloat"));
const _utils_1 = require("@utils"); // Component
var ArticleTeaser = function ArticleTeaser(_ref) {
    var _ref$layout = _ref.layout, layout = _ref$layout === void 0 ? 'overlap' : _ref$layout, _ref$orientation = _ref.orientation, orientation = _ref$orientation === void 0 ? 'left' : _ref$orientation, props = _objectWithoutPropertiesLoose(_ref, ["layout", "orientation"]);
    return /*#__PURE__*/ react_1.default.createElement(StyledMargin, {
        noGutter: true
    }, layout === 'overlap' && /*#__PURE__*/ react_1.default.createElement(ArticleTeaserOverlap_1.default, Object.assign({}, props, {
        orientation: orientation
    })), layout === 'center' && /*#__PURE__*/ react_1.default.createElement(ArticleTeaserCenter_1.default, props), layout === 'corner' && /*#__PURE__*/ react_1.default.createElement(ArticleTeaserCorner_1.default, props), layout === 'float' && /*#__PURE__*/ react_1.default.createElement(ArticleTeaserFloat_1.default, Object.assign({}, props, {
        orientation: orientation
    })));
}; // Styling
var StyledMargin = styled_components_1.default(atoms_1.Margin).withConfig({
    displayName: "ArticleTeaser__StyledMargin",
    componentId: "jahw3s-0"
})(["padding:32px 0;", "{padding:40px 0;}", "{padding:48px 0;}", "{padding:64px 0;}"], _utils_1.mediaQuery('tablet'), _utils_1.mediaQuery('laptop'), _utils_1.mediaQuery('desktop')); // Types
exports.default = ArticleTeaser;
